import React from "react";
import { MdClose } from "react-icons/md";

const ChipList = ({
  items = [],
  field = "",
  keyField = "",
  onRemove = (item) => {
    console.log(item);
  },
}) => (
  <div>
    {items?.map((item) => (
      <div
        key={item[keyField] ?? item[field]}
        style={{
          display: "inline-block",
          height: "32px",
          color: "rgba(0,0,0,0.6)",
          lineHeight: "32px",
          padding: "0 12px",
          borderRadius: "16px",
          backgroundColor: "#e4e4e4",
          marginBottom: "5px",
          marginRight: "5px",
        }}
      >
        {item[field]}
        <MdClose
          onClick={() => {
            if (typeof onRemove === "function") {
              onRemove(item);
            }
          }}
        />
      </div>
    ))}
  </div>
);

export default ChipList;
